const CardWithImage = ({ name, img }: any) => {
  return (
    <div className="min-w-[250px] mr-3 h-[350px] flex flex-col overflow-hidden bg-white shadow-md cursor-pointer translate-z-0 no-underline text-current relative rounded-lg">
      <div
        style={{
          transition: "all .2s ease-in-out",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          backgroundPosition: "50% 50%",
          backgroundImage: "url(" + img + ")",
        }}
        className=" w-full h-full hover:scale-110 transition-transform absolute"
      />
      <div className="m-auto  pt-7 pb-4 pl-4 pr-4 text-white text-left ">
        <span className="text-2xl  text-[#000046] font-bold font-Nunito ">
          {name}
        </span>
      </div>
    </div>
  );
};

export default CardWithImage;
